// extracted by mini-css-extract-plugin
export var chevronIcon = "_68-2";
export var teamName = "_68-1";
export var teamSwitcherButton = "_68-0";